import {
  Component,
  OnInit,
  inject,
  NgZone,
  ViewChild,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactionsComponent } from '@app/shared/components/reactions/reactions.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenuItem, MessageService } from 'primeng/api';
import { TabsModule } from 'primeng/tabs';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { RouteUtils } from '@app/core/utils/route.util';
import { ComentarioService } from '@app/shared/components/api/services/comentario.service';
import { CampanhaService } from '@app/shared/components/api/services/campanha.service';
import { ListaComentariosComponent } from '@app/shared/components/lista-comentarios/lista-comentarios.component';
import { UserService } from '@app/auth/services/user.service';
import { SafeUrlPipe } from '@app/shared/pipes/safe-url.pipe';
import { AnexoFicheiroService } from '@app/shared/components/api/services/anexo-ficheiro.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SocialIconPipe } from '@app/shared/pipes/social-icon.pipe';
import { TrimTextPipe } from '@app/shared/pipes/trim-text.pipe';
import { DialogService } from 'primeng/dynamicdialog';
import { SkeletonLoaderComponent } from '@app/shared/components/skeleton-loader/skeleton-loader.component';
import { ListaPagamentosComponent } from '@app/shared/components/lista-pagamentos/lista-pagamentos.component';
import { UtilizadoresService } from '@app/shared/components/api/services/utilizadores.service';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';
import { AuthService } from '@app/auth/services/auth.service';
import { AuthRedirectService } from '@app/auth/services/auth-redirect.service';

import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-detalhe-campanha',
  imports: [
    CommonModule,
    ReactionsComponent,
    BreadcrumbModule,
    TabsModule,
    DataVoidComponent,
    ListaComentariosComponent,
    SafeUrlPipe,
    SocialIconPipe,
    TrimTextPipe,
    SkeletonLoaderComponent,
    ListaPagamentosComponent,
    MoneyPipe,
    RouterModule,
    DialogModule,
  ],
  providers: [
    CampanhaService,
    ComentarioService,
    AnexoFicheiroService,
    DialogService,
    UserService,
    UtilizadoresService,
    AuthService,
  ],
  templateUrl: './detalhe-campanha.component.html',
  styleUrl: './detalhe-campanha.component.scss',
  standalone: true,
})
export class DetalheCampanhaComponent implements OnInit, OnDestroy {
  @ViewChild('nativeVideo') nativeVideo!: ElementRef<HTMLVideoElement>;
  @ViewChild('youtubePlayerIframe')
  youtubePlayerIframe!: ElementRef<HTMLIFrameElement>;

  isPlaying: boolean = false;
  currentTime: number = 0;
  duration: number = 0;
  progressPercent: number = 0;
  isOverlayVisible: boolean = false;
  volume: number = 70;
  isMuted: boolean = true;
  private overlayTimeout: any;
  private ytPlayer: any;
  private ytInterval: any;

  items: MenuItem[] = [];
  home: MenuItem | undefined;
  private readonly messageService = inject(MessageService);
  private readonly campanhaService = inject(CampanhaService);
  private readonly comentarioService = inject(ComentarioService);
  private readonly anexoFicheiroService = inject(AnexoFicheiroService);
  private readonly userService = inject(UserService);
  private readonly utilizadoresService = inject(UtilizadoresService);

  private readonly ngZone = inject(NgZone);
  private readonly ativateRouder = inject(ActivatedRoute);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly authRedirectService = inject(AuthRedirectService);

  TabIndex: number = 0;
  showSidebarComment: boolean = false;
  campanha: any;
  campanhaID: any;
  comentarios: any;
  IsprofileComplet: boolean = true;
  IsAuthenticad: boolean = false;
  imgPreview?: any;
  docPreview?: any;
  imgRawUrl?: string;
  docRawUrl?: string;
  showDocModal: boolean = false;
  showImageModal: boolean = false;
  videoPreview?: string;
  videoLink: string = '';
  imgInfo?: { nome: string; tamanho: string; tipo: string };
  docInfo?: { nome: string; tamanho: string; tipo: string };
  VidInfo?: { nome: string; tamanho: string; tipo: string };
  loading: boolean = false;
  userID: string | null = this.userService.getUserId();

  ngOnInit(): void {
    // this.checkProfileUSer();
    const rawId = this.ativateRouder.snapshot.paramMap.get('id');
    const rawNome = this.ativateRouder.snapshot.paramMap.get('nome');

    // Garante que usamos sempre o ID (numérico/identificador real) e nunca o nome/título da campanha
    let candidateId = rawId;
    if (
      rawNome &&
      (!candidateId || isNaN(Number(candidateId))) &&
      !isNaN(Number(rawNome))
    ) {
      candidateId = rawNome;
    }

    const id = candidateId ? RouteUtils.decryptId(candidateId) : null;
    this.campanhaID = id;
    if (this.campanhaID) {
      this.getCampanhaByID(this.campanhaID);
    }
    this.items = [{ label: 'Detalhe da Campanha' }];
    this.home = { icon: 'pi pi-home', routerLink: '/' };
    this.authService.isAuthenticatedChange().subscribe((isAuth) => {
      this.IsAuthenticad = isAuth;
    });

    this.ativateRouder.fragment.subscribe((fragment) => {
      if (fragment === 'comentarios') {
        this.onCommentClicked();
      }
    });
  }

  onCommentClicked(): void {
    this.showSidebarComment = true;
    this.ativateTab(2);
    setTimeout(() => {
      const element =
        document.getElementById('tab-comentarios') ||
        document.querySelector('.detail-tabs-wrapper');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      const textarea = document.querySelector(
        '.floating-comment-card textarea, .novo-comentario-textarea',
      ) as HTMLTextAreaElement;
      if (textarea) {
        textarea.focus();
      }
    }, 100);
  }

  onCommentAdded(): void {
    if (this.campanhaID) {
      this.getCampanhaByID(this.campanhaID, false);
    }
  }

  getCampanhaByID(id: string, showSkeleton: boolean = true) {
    if (showSkeleton) {
      this.loading = true;
    }
    const params: any = {};
    if (this.userID && this.userID.trim() !== '') {
      params.UtilizadorCurtiuID = this.userID;
    }
    this.campanhaService
      .show(id, Object.keys(params).length > 0 ? params : undefined)
      .subscribe({
        next: (res) => {
          this.campanha = res.data;

          if (
            this.campanha.estado === 'Pendente' ||
            this.campanha.estado === 'Recusada' ||
            this.campanha.estado === 'Suspensa' ||
            this.campanha.estado === 'Rascunho'
          ) {
            this.router.navigate(['/']);
          }
          const fotoAnexo = this.campanha.anexoCampanha?.find(
            (a: any) => a?.tipoAnexoCampanha?.tipo === 'Imagem',
          );
          const DocAnexo = this.campanha.anexoCampanha?.find(
            (a: any) => a?.tipoAnexoCampanha?.tipo === 'Apresentação',
          );
          const videoAnexo = this.campanha.anexoCampanha?.find(
            (a: any) => a?.tipoAnexoCampanha?.tipo === 'Video',
          );
          const rawLink = videoAnexo?.anexo?.url || '';

          if (rawLink) {
            this.videoLink = this.getEmbedUrl(rawLink);
            setTimeout(() => {
              if (this.videoLink.includes('youtube.com/embed/')) {
                this.initYoutubePlayer();
              } else if (this.videoLink.includes('vimeo.com/')) {
                this.isPlaying = true;
              }
            }, 500);
          } else {
            this.videoLink = '';
            this.getVideoCampanha(videoAnexo?.anexo?.id);
          }
          this.getPhotoCampanha(fotoAnexo?.anexo?.id);
          this.getDocsCampanha(DocAnexo?.anexo?.id);
          this.getCommentsByCampnhaID();
          this.loading = false;
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
        },
      });
  }

  getEmbedUrl(url: string): string {
    if (!url) return '';

    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const originParam = origin ? `&origin=${encodeURIComponent(origin)}` : '';

    // Videos  YouTube longos
    if (url.includes('youtube.com/watch?v=')) {
      const id = url.split('v=')[1].split('&')[0];
      return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&enablejsapi=1${originParam}`;
    }

    // Videos YouTube curtos
    if (url.includes('youtu.be/')) {
      const id = url.split('youtu.be/')[1].split('?')[0];
      return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&enablejsapi=1${originParam}`;
    }

    //  Videos Vimeo
    if (url.includes('vimeo.com/')) {
      const id = url.split('vimeo.com/')[1].split('?')[0];
      return `https://player.vimeo.com/video/${id}?autoplay=1&loop=1&muted=1&background=0&api=1`;
    }

    // Direct link (.mp4 etc.)
    return url;
  }

  openFile(url?: string) {
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  }

  abrirDoc(event?: Event): void {
    if (event) event.stopPropagation();
    if (this.docPreview || this.docRawUrl) {
      this.showDocModal = true;
    }
  }

  abrirImagem(event?: Event): void {
    if (event) event.stopPropagation();
    if (this.imgPreview || this.imgRawUrl) {
      this.showImageModal = true;
    }
  }

  descarregarFicheiro(url: string | undefined, nome?: string, event?: Event): void {
    if (event) event.stopPropagation();
    if (!url) return;
    const a = document.createElement('a');
    a.href = url;
    a.download = nome || 'anexo';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  abrirNovaAba(url: string | undefined, event?: Event): void {
    if (event) event.stopPropagation();
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  getDocsCampanha(id: any) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (DocRes: any) => {
        const blob = DocRes instanceof Blob ? DocRes : new Blob([DocRes], { type: 'application/pdf' });
        this.docRawUrl = URL.createObjectURL(blob);
        this.docPreview = this.sanitizer.bypassSecurityTrustResourceUrl(this.docRawUrl);
        this.docInfo = {
          nome: `Apresentação_${id}.pdf`,
          tamanho: `${(blob.size / 1024).toFixed(2)} KB`,
          tipo: blob.type || 'application/pdf',
        };
      },
      error: (err) => console.error(err),
    });
  }

  getPhotoCampanha(id: any) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (fotoRes: any) => {
        const blob = fotoRes instanceof Blob ? fotoRes : new Blob([fotoRes], { type: 'image/jpeg' });
        this.imgRawUrl = URL.createObjectURL(blob);
        this.imgPreview = this.sanitizer.bypassSecurityTrustUrl(this.imgRawUrl) as any;
        this.imgInfo = {
          nome: `Imagem_${id}.jpg`,
          tamanho: `${(blob.size / 1024).toFixed(2)} KB`,
          tipo: blob.type || 'image/jpeg',
        };
      },
      error: (err) => console.error(err),
    });
  }

  getVideoCampanha(id: any) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (vidRes: any) => {
        const blob = vidRes instanceof Blob ? vidRes : new Blob([vidRes]);
        this.videoPreview = this.sanitizer.bypassSecurityTrustResourceUrl(
          URL.createObjectURL(blob),
        ) as any;
        this.VidInfo = {
          nome: `Video_${id}.mp4`,
          tamanho: `${(blob.size / 1024).toFixed(2)} KB`,
          tipo: blob.type || 'image/jpg',
        };
      },
      error: (err) => console.error(err),
    });
  }

  getCommentsByCampnhaID() {
    const params = {
      PageSize: 5,
      PageNumber: 1,
      orderBy: 'id desc',
      CampanhaID: this.campanhaID,
    };

    this.comentarioService.list(params).subscribe({
      next: (result) => {
        this.comentarios = result.data;
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  getPercent(campanha: any): number {
    if (!campanha?.metaArrecadar) return 0;
    return Math.round((campanha.valorArrecado / campanha.metaArrecadar) * 100);
  }

  getPctClass(pct: number): string {
    if (pct >= 70) return 'high';
    if (pct >= 30) return 'mid';
    return 'low';
  }

  getDaysClass(dias: number): string {
    if (dias <= 10) return 'urgent';
    if (dias <= 30) return 'warning';
    return 'normal';
  }

  ativateTab(index: number) {
    this.TabIndex = index;
    if (index === 2) {
      this.showSidebarComment = true;
    }
  }

  // financiarCampanha() {
  //   this.router.navigate(['/detalhe-pagamento/', this.campanhaID]);
  // }

  checkProfileUSer() {
    this.utilizadoresService
      .checkPerfilUser(this.userService.getUserId() || '')
      .subscribe({
        next: (res: any) => {
          if (res?.retorno.codigo === 200) {
            this.IsprofileComplet = res?.data;
          } else {
            this.IsprofileComplet = false;
          }
        },
      });
  }

  isCampanhaRecompensa(): boolean {
    return (
      Number(this.campanha?.tipoFinanciamentoENUM) === 3 ||
      String(this.campanha?.tipoFinanciamento).toLowerCase() === 'recompensa' ||
      (Array.isArray(this.campanha?.recompensa) && this.campanha.recompensa.length > 0)
    );
  }

  getRecompensas(): any[] {
    return Array.isArray(this.campanha?.recompensa) ? this.campanha.recompensa : [];
  }

  getSomaRecompensas(): number {
    const list = this.getRecompensas();
    return list.reduce((total: number, r: any) => {
      const valor = Number(r.valor) || 0;
      const qtd = Number(r.quantidade) || 1;
      return total + valor * qtd;
    }, 0);
  }

  callRouteFinacy(id: string, event: Event, recompensaId?: number) {
    event.stopPropagation();
    if (!this.IsAuthenticad) {
      const returnUrl = recompensaId
        ? '/financiar-campanha/' + id + '?recompensaId=' + recompensaId
        : '/financiar-campanha/' + id;
      this.authRedirectService.redirectToRegister(returnUrl);
      return;
    }

    if (this.IsprofileComplet) {
      if (recompensaId) {
        this.router.navigate(['/financiar-campanha/', id], {
          queryParams: { recompensaId },
        });
      } else {
        this.router.navigate(['/financiar-campanha/', id]);
      }
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Perfil incompleto',
        detail: 'Complete os dados da sua conta no seu perfil para continuar.',
        life: 8000,
      });
      this.router.navigate(['/perfil']);
    }
  }

  openRegister(returnUrl?: string): void {
    this.authRedirectService.redirectToRegister(returnUrl);
  }

  openLogin(returnUrl?: string): void {
    this.authRedirectService.redirectToLogin(returnUrl);
  }

  ngOnDestroy(): void {
    this.stopYTProgressTimer();
    if (this.overlayTimeout) {
      clearTimeout(this.overlayTimeout);
    }
  }

  private initYoutubePlayer() {
    if (typeof window === 'undefined') return;

    if (!(window as any).YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

      (window as any).onYouTubeIframeAPIReady = () => {
        this.createYTPlayer();
      };
    } else {
      this.createYTPlayer();
    }
  }

  private createYTPlayer() {
    if (typeof window === 'undefined' || !(window as any).YT) return;

    if (this.ytPlayer) {
      try {
        this.ytPlayer.destroy();
      } catch (e) {}
    }

    this.ytPlayer = new (window as any).YT.Player('yt-player', {
      events: {
        onReady: () => {
          this.duration = this.ytPlayer.getDuration();
          this.isPlaying = true;
          this.startYTProgressTimer();
          this.applyVolumeSettings();
        },
        onStateChange: (event: any) => {
          this.ngZone.run(() => {
            const playerState = event.data;
            if (playerState === (window as any).YT.PlayerState.PLAYING) {
              this.isPlaying = true;
              this.startYTProgressTimer();
            } else if (playerState === (window as any).YT.PlayerState.PAUSED) {
              this.isPlaying = false;
              this.stopYTProgressTimer();
            } else if (playerState === (window as any).YT.PlayerState.ENDED) {
              this.isPlaying = false;
              this.stopYTProgressTimer();
              this.currentTime = 0;
              this.progressPercent = 0;
            }
          });
        },
      },
    });
  }

  private startYTProgressTimer() {
    this.stopYTProgressTimer();
    this.ytInterval = setInterval(() => {
      if (this.ytPlayer && typeof this.ytPlayer.getCurrentTime === 'function') {
        this.ngZone.run(() => {
          this.currentTime = this.ytPlayer.getCurrentTime();
          this.duration = this.ytPlayer.getDuration() || 0;
          this.progressPercent =
            this.duration > 0 ? (this.currentTime / this.duration) * 100 : 0;
        });
      }
    }, 250);
  }

  private stopYTProgressTimer() {
    if (this.ytInterval) {
      clearInterval(this.ytInterval);
      this.ytInterval = null;
    }
  }

  onNativeTimeUpdate() {
    if (this.nativeVideo && this.nativeVideo.nativeElement) {
      const video = this.nativeVideo.nativeElement;
      this.currentTime = video.currentTime;
      this.progressPercent =
        this.duration > 0 ? (this.currentTime / this.duration) * 100 : 0;
    }
  }

  onNativeLoadedMetadata() {
    if (this.nativeVideo && this.nativeVideo.nativeElement) {
      this.duration = this.nativeVideo.nativeElement.duration;
      this.applyVolumeSettings();
    }
  }

  onNativePlayStateChange(playing: boolean) {
    this.isPlaying = playing;
  }

  togglePlay() {
    if (
      this.videoPreview &&
      this.nativeVideo &&
      this.nativeVideo.nativeElement
    ) {
      const video = this.nativeVideo.nativeElement;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    } else if (this.videoLink) {
      if (this.ytPlayer) {
        const state = this.ytPlayer.getPlayerState();
        if (state === (window as any).YT.PlayerState.PLAYING) {
          this.ytPlayer.pauseVideo();
        } else {
          this.ytPlayer.playVideo();
        }
      } else if (this.videoLink.includes('vimeo.com/')) {
        const iframe = this.youtubePlayerIframe?.nativeElement;
        if (iframe && iframe.contentWindow) {
          this.isPlaying = !this.isPlaying;
          iframe.contentWindow.postMessage(
            JSON.stringify({
              method: this.isPlaying ? 'play' : 'pause',
            }),
            '*',
          );
        }
      }
    }
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
    this.applyVolumeSettings();
  }

  onVolumeChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.volume = Number(target.value);
    this.isMuted = this.volume === 0;
    this.applyVolumeSettings();
  }

  applyVolumeSettings() {
    // 1. Native Video
    if (
      this.videoPreview &&
      this.nativeVideo &&
      this.nativeVideo.nativeElement
    ) {
      const video = this.nativeVideo.nativeElement;
      video.muted = this.isMuted;
      video.volume = this.volume / 100;
    }
    // 2. YouTube
    if (
      this.videoLink &&
      this.ytPlayer &&
      typeof this.ytPlayer.setVolume === 'function'
    ) {
      if (this.isMuted) {
        this.ytPlayer.mute();
      } else {
        this.ytPlayer.unMute();
        this.ytPlayer.setVolume(this.volume);
      }
    }
    // 3. Vimeo
    if (this.videoLink && this.videoLink.includes('vimeo.com/')) {
      const iframe = this.youtubePlayerIframe?.nativeElement;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          JSON.stringify({
            method: 'setVolume',
            value: this.isMuted ? 0 : this.volume / 100,
          }),
          '*',
        );
        iframe.contentWindow.postMessage(
          JSON.stringify({
            method: 'setMuted',
            value: this.isMuted,
          }),
          '*',
        );
      }
    }
  }

  seekVideo(event: MouseEvent) {
    const container = event.currentTarget as HTMLElement;
    const rect = container.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const width = rect.width;
    const clickPercent = Math.max(0, Math.min(1, clickX / width));

    if (this.duration > 0) {
      const newTime = clickPercent * this.duration;
      if (
        this.videoPreview &&
        this.nativeVideo &&
        this.nativeVideo.nativeElement
      ) {
        this.nativeVideo.nativeElement.currentTime = newTime;
      } else if (
        this.videoLink &&
        this.ytPlayer &&
        typeof this.ytPlayer.seekTo === 'function'
      ) {
        this.ytPlayer.seekTo(newTime, true);
        this.currentTime = newTime;
        this.progressPercent = clickPercent * 100;
      }
    }
  }

  formatTime(timeInSeconds: number): string {
    if (isNaN(timeInSeconds)) return '0:00';
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  showOverlay() {
    this.isOverlayVisible = true;
    this.resetOverlayTimeout();
  }

  hideOverlay() {
    if (this.isPlaying) {
      this.isOverlayVisible = false;
    }
  }

  resetOverlayTimeout() {
    this.isOverlayVisible = true;
    if (this.overlayTimeout) {
      clearTimeout(this.overlayTimeout);
    }
    if (this.isPlaying) {
      this.overlayTimeout = setTimeout(() => {
        this.isOverlayVisible = false;
      }, 2500);
    }
  }

  onOverlayClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (
      target.closest('.progress-container') ||
      target.closest('.video-header') ||
      target.closest('.volume-container')
    ) {
      return;
    }
    this.togglePlay();
  }
}
